import { useRef } from 'react'
import Modal from '../common/Modal'
import { cn, helperTextClass, iconButtonClass } from '../../utils/theme'

interface ConfirmDeleteModalProps {
  isOpen: boolean
  productName?: string
  onConfirm: () => void
  onClose: () => void
  isDeleting?: boolean
}

export function ConfirmDeleteModal({
  isOpen,
  productName,
  onConfirm,
  onClose,
  isDeleting,
}: ConfirmDeleteModalProps) {
  const confirmButtonRef = useRef<HTMLButtonElement | null>(null)

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Eliminar producto"
      initialFocusRef={confirmButtonRef}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className={cn(iconButtonClass(), 'px-4 py-2 text-sm font-medium')}
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            ref={confirmButtonRef}
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className={cn(
              'inline-flex items-center rounded-full bg-rose-600 px-4 py-2 text-sm font-semibold text-white transition-colors',
              'hover:bg-rose-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-500 focus-visible:ring-offset-2',
              'disabled:cursor-not-allowed disabled:opacity-60 dark:focus-visible:ring-offset-neutral-900',
            )}
          >
            {isDeleting ? 'Eliminando…' : 'Eliminar'}
          </button>
        </div>
      }
    >
      <p className={helperTextClass()}>
        Esta acción no se puede deshacer. ¿Deseas eliminar <strong>{productName}</strong>?
      </p>
    </Modal>
  )
}

export default ConfirmDeleteModal
